import {Button, Card, Layout, Modal, Text} from '@ui-kitten/components';
import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {openUrl} from '../../../../helpers/linkingNavigate';
import {isLandscape, px, wp} from '../../../../utils';
import {TitleRow} from '../../../components';
import Autolink from 'react-native-autolink';

const DetailModal = ({onClose, data}) => {
  return (
    <Modal
      visible={Boolean(data)}
      backdropStyle={styles.backdrop}
      onBackdropPress={onClose}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title={'Announcement'}
            type="primary"
            iconName="close-circle-outline"
            onIconClick={onClose}
            containerStyle={styles.containerBlock}
          />
          <ScrollView contentContainerStyle={styles.scrollView}>
            <Text style={styles.title}>{data?.title}</Text>
            <Autolink
              style={styles.description}
              component={Text}
              text={data?.text}
            />

            {data?.link?.length > 0 && (
              <Button onPress={() => (data.link ? openUrl(data?.link) : null)}>
                {data.media_type.includes('image')
                  ? 'View image'
                  : data.media_type.includes('video')
                  ? 'View video'
                  : 'View link'}
              </Button>
            )}
          </ScrollView>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    maxHeight: px(450),
    width: isLandscape() ? wp(30) : wp(90),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  scrollView: {
    padding: px(17),
  },
  containerBlock: {},
  title: {
    fontSize: px(22),
    fontWeight: '600',
    marginBottom: px(20),
  },
  link: {
    color: '#f94c2a',
    textDecorationLine: 'underline',
  },
  description: {
    marginBottom: 10,
    fontSize: px(18),
  },
});

export default DetailModal;
